/**
 * The catalog of audit actions. It lives in shared code so the audit viewer can
 * offer the same set of filters the server writes, with no chance of drift.
 */
export const AUDIT_ACTIONS = {
  LOGIN_SUCCEEDED: 'auth.login_succeeded',
  LOGIN_FAILED: 'auth.login_failed',
  LOGOUT: 'auth.logout',
  PASSWORD_CHANGED: 'auth.password_changed',
  PASSWORD_RESET_REQUESTED: 'auth.password_reset_requested',
  PASSWORD_RESET_COMPLETED: 'auth.password_reset_completed',
  INVITATION_CREATED: 'auth.invitation_created',
  INVITATION_ACCEPTED: 'auth.invitation_accepted',

  USER_CREATED: 'user.created',
  USER_UPDATED: 'user.updated',
  USER_DEACTIVATED: 'user.deactivated',
  USER_DELETED: 'user.deleted',
  USER_ROLES_CHANGED: 'user.roles_changed',
  USER_ACCESS_GRANTED: 'user.access_granted',
  USER_ACCESS_REVOKED: 'user.access_revoked',

  WORK_ORDER_CREATED: 'work_order.created',
  WORK_ORDER_UPDATED: 'work_order.updated',
  WORK_ORDER_STATUS_CHANGED: 'work_order.status_changed',
  WORK_ORDER_ASSIGNED: 'work_order.assigned',
  WORK_ORDER_CLOSED: 'work_order.closed',
  WORK_ORDER_PURGED: 'work_order.purged',
  REMINDER_SETTINGS_UPDATED: 'reminder_settings.updated',

  INVESTIGATION_SAVED: 'investigation.saved',

  PROPOSAL_VERSION_CREATED: 'proposal.version_created',
  PROPOSAL_VERSION_UPDATED: 'proposal.version_updated',
  PROPOSAL_SUBMITTED: 'proposal.submitted',
  PROPOSAL_APPROVED: 'proposal.approved',
  PROPOSAL_REJECTED: 'proposal.rejected',
  PROPOSAL_WITHDRAWN: 'proposal.withdrawn',
  PROPOSAL_REVISION_REQUESTED: 'proposal.revision_requested',
  PROPOSAL_REFERRED_TO_CO: 'proposal.referred_to_co',
  PROPOSAL_ENDORSED_BY_COR: 'proposal.endorsed_by_cor',
  COST_ITEM_CHANGED: 'proposal.cost_item_changed',

  RESPONSE_LINE_RECORDED: 'response_line.recorded',
  RESPONSE_LINE_CO_DISCRETION: 'response_line.co_discretion_recorded',
  COMPETITION_REQUIRED_CHANGED: 'competition.required_changed',
  COMPETITION_EXCEPTION_REQUESTED: 'competition.exception_requested',
  COMPETITION_EXCEPTION_DECIDED: 'competition.exception_decided',

  PROCUREMENT_SAVED: 'procurement.saved',
  SCHEDULE_SAVED: 'execution.schedule_saved',
  COMPLETION_SAVED: 'completion.saved',

  COMMENT_CREATED: 'comment.created',
  ATTACHMENT_UPLOADED: 'attachment.uploaded',
  ATTACHMENT_DOWNLOADED: 'attachment.downloaded',
  ATTACHMENT_DELETED: 'attachment.deleted',

  CONFIG_CHANGED: 'configuration.changed',
  MARKUP_CHANGED: 'configuration.markup_changed',
  FACILITY_CREATED: 'facility.created',
  FACILITY_UPDATED: 'facility.updated',
  TASK_ORDER_CREATED: 'task_order.created',
  TASK_ORDER_UPDATED: 'task_order.updated',
  CATEGORY_CHANGED: 'repair_category.changed',
  ROLE_CHANGED: 'role.changed',
  APPROVAL_AUTHORITY_CHANGED: 'configuration.approval_authority_changed',

  EXPORT_GENERATED: 'report.export_generated',

  EMPLOYEE_DOCS_TEMPLATE_CHANGED: 'employee_docs.template_changed',
  EMPLOYEE_DOCS_PACKAGE_CREATED: 'employee_docs.package_created',
  EMPLOYEE_DOCS_PACKAGE_REVIEWED: 'employee_docs.package_reviewed',
  EMPLOYEE_DOCS_PACKAGE_RELEASED: 'employee_docs.package_released',
  EMPLOYEE_DOCS_ACCESS_REVOKED: 'employee_docs.access_revoked',
  EMPLOYEE_DOCS_PACKAGE_DELETED: 'employee_docs.package_deleted',
  EMPLOYEE_DOCS_FILE_VIEWED: 'employee_docs.file_viewed',
} as const;

export type AuditAction = (typeof AUDIT_ACTIONS)[keyof typeof AUDIT_ACTIONS];

export const AUDIT_ACTION_LIST: readonly AuditAction[] = Object.values(AUDIT_ACTIONS);
